<!-- Last Speciality from Category Deleted Message -->
<div *ngIf="formMode == FormMode.Edit && islastCategoryAccepted && !editCompleted" class="alert alert-danger"
  role="alert">
  <p>{{'FRONT_USER.ERRORS_MESSAGES.LastCategoryDeleted' | translate}}</p>
</div>

<!-- Under Review Message -->
<div *ngIf="isAccountReview" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-warning"></i>
    <p>{{'ADMIN_USER.SUPPPLIER_FORMS.AccountReviewed'| translate}}</p>
    <p>{{'ADMIN_USER.SUPPPLIER_FORMS.RequestNumber'| translate}} : {{baseRequestDTO?.RequestNumber}}</p>
    <hr>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{workspaceUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.Workspace'| translate}}
      </a>
    </p>
  </div>
</div>

<!--Basic Registration Info Header -->
<!-- <ng-container *ngIf="formMode != FormMode.Add && !editCompleted" #basicRegistrationInfo>
  <div class="form-container">
    <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.BASIC_INFO'| translate}}</h4>
  </div>
  <div class="form-container">
    <div class="form-group">
      <label for="basicInfoEmail">{{ 'FRONT_USER.REGISTRATION_FORM.USER_NAME' | translate}}</label>
      <input type="text" [disabled]="true" id="basicInfoEmail" name="basicInfoEmail" class="form-control"
        value="{{basicRegistrationInfoResponseObj?.Data?.Email}}" />
    </div>
    <div class="form-group">
      <label for="userType">{{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE'| translate}}</label>
      <input type="text" [disabled]="true" id="userType" name="userType" class="form-control"
        value="{{basicInfoSupplierType}}" />
    </div>
    <div class="form-group">
      <label for="userType">{{'FRONT_USER.REGISTRATION_FORM.SUPPLIER_NUMBER'| translate}}</label>
      <input type="text" [disabled]="true" id="userType" name="userType" class="form-control"
        value="{{supplierNumber}}" />
    </div>
  </div>
</ng-container> -->
<!-- Title - SUPPLIER_IS - Tabs - Basic Registration Info Header -->
<div #formContainer [hidden] = "!IsSupplierRegistrationAvailable && formMode == FormMode.Add">
<form *ngIf="!editCompleted" [formGroup]="supplierRegistrationForm" #supplierChild>
<!--Basic Registration Info Header -->
  <ng-container *ngIf="formMode != FormMode.Add && !editCompleted" #basicRegistrationInfo>
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.BASIC_INFO'| translate}}</h4>
    </div>
    <div class="form-container">
      <div class="form-group">
        <label for="basicInfoEmail">{{ 'FRONT_USER.REGISTRATION_FORM.USER_NAME' | translate}}</label>
        <input type="text" [disabled]="true" id="basicInfoEmail" name="basicInfoEmail" class="form-control"
          value="{{basicRegistrationInfoResponseObj?.Data?.Email}}" />
      </div>
      <div class="form-group">
        <label for="userType">{{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE'| translate}}</label>
        <input type="text" [disabled]="true" id="userType" name="userType" class="form-control"
          value="{{basicInfoSupplierType}}" />
      </div>
      <div class="form-group">
        <label for="userType">{{'FRONT_USER.REGISTRATION_FORM.SUPPLIER_NUMBER'| translate}}</label>
        <input type="text" [disabled]="true" id="userType" name="userType" class="form-control"
          value="{{supplierNumber}}" />
      </div>
    </div>
  </ng-container>
  <!-- Title -->
  <div class="form-container">
    <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.SUPPLIER'| translate}}</h4>
  </div>
  <!-- SUPPLIER_IS Singel-Select-DDL-->
  <div class="form-container">
    <div class="form-group">
      <label
        for="ddlSupplierIs">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.LABEL' | translate}}</label>
      <span class="red"> *</span>
      <select formControlName="IsLocalSupplier" (change)="onSupplierIsChange($event)" id="ddlSupplierIs"
        class="form-control" name="ddlSupplierIs">
        <option [value]="''" selected>
          {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
        </option>
        <option [value]="true">
          {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.LOCAL' | translate}}
        </option>
        <option [value]="false">
          {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.FOREIGN' | translate}}
        </option>
      </select>
      <div *ngIf="(isTabOneSubmitted || formSubmitted) && getFormControls?.IsLocalSupplier?.invalid" class="red ">
        <div *ngIf="getFormControls?.IsLocalSupplier?.errors?.required">
          {{'FRONT_USER.This_Field_Is_Required'| translate}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showUnderconstructionMessage">
    <div class="alert alert-warning" role="alert">
      <div class="alignC">
        <p>
          <img src="https://www.suezcanal.gov.eg/Style%20Library/Images/page_under_construction.png"
            alt="page_under_construction.png" style="margin: 5px;">
        </p>
        <p style="color: #a88447;">
          <span>{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.SORRY' | translate}}</span>
          <br>
          <span>{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.UNDER_CONSTRUCTION' | translate}}</span>
          <br>
        </p>
        <p>
          <span
            style="color: #a88447;">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_IS.CHECK_SOON' | translate}}</span>
        </p>
      </div>
    </div>
  </div>
  <!-- Tabs  -->
  <div
    [hidden]="!(IsSupplierRegistrationType && !showUnderconstructionMessage && getFormControls?.IsLocalSupplier?.value != '')">
    <tabset #supplierTabs>
      <!---BASIC_SUPPLIER_INFO TAB-->
      <tab #basicSupplierInfoTab heading="{{ 'FRONT_USER.SUPPLIER_TABS.BASIC_SUPPLIER_INFO' | translate}}">
        <div class="form-container" formGroupName="BasicSupplierInfoTab">
          <!-- NATURE_OF_SUPPLIER Singel-Select-DDL-->
          <div class="form-group">
            <label
              for="ddlSupplierNature">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.NATURE_OF_SUPPLIER' | translate}}</label>
            <span class="red"> *</span>
            <select formControlName="SupplierNatureId" id="ddlSupplierNature" class="form-control"
              name="ddlSupplierNature">
              <option [value]="''" selected>
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
              </option>
              <ng-container *ngFor="let supplierNature of supplierNatures">
                <option *ngIf="currentLanguage == Languages.English" [value]="supplierNature.Id">
                  {{supplierNature.NameEN}}
                </option>
                <option *ngIf="currentLanguage == Languages.Arabic" [value]="supplierNature.Id">
                  {{supplierNature.NameAR}}
                </option>
              </ng-container>
            </select>
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.SupplierNatureId?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.SupplierNatureId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
          <!-- SUPPLIER_TYPE Singel-Select-DDL-->
          <div class="form-group">
            <label
              for="ddlSupplierType">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.SUPPLIER_TYPE' | translate}}</label>
            <span class="red"> *</span>
            <select formControlName="SupplierTypeId" (change)="onSupplierTypeChange($event)" id="ddlSupplierType"
              class="form-control" name="ddlSupplierType">
              <option [value]="''" selected>
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
              </option>
              <ng-container *ngFor="let supplierType of supplierTypes">
                <option *ngIf="currentLanguage == Languages.English" [value]="supplierType.Id">
                  {{supplierType.NameEN}}
                </option>
                <option *ngIf="currentLanguage == Languages.Arabic" [value]="supplierType.Id">
                  {{supplierType.NameAR}}
                </option>
              </ng-container>
            </select>
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.SupplierTypeId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
          <!-- COMPANY_NAME Text-->
          <div class="form-group">
            <label
              for="txtCompanyName">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMPANY_NAME' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="CompanyName" id="txtCompanyName" class="form-control"
              name="txtCompanyName"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.CompanyName?.dirty && getBasicSupplierInfoTabControls.CompanyName?.errors) }" />

            <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CompanyName?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.CompanyName?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.CompanyName?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.CompanyName?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- COMMERCIAL_NAME Text-->
          <div class="form-group">
            <label
              for="txtCommercialName">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMMERCIAL_NAME' | translate}}</label>
            <input type="text" formControlName="CommercialName" id="txtCommercialName" class="form-control"
              name="txtCommercialName" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CommercialName?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialName?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialName?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- COMMERCIAL_RECORD_NUMBER Text-->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value != 2">
            <label
              for="txtCommercialRecordNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMMERCIAL_RECORD_NUMBER' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="CommercialRecordNumber" id="txtCommercialRecordNumber"
              class="form-control" name="txtCommercialRecordNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.CommercialRecordNumber?.dirty && getBasicSupplierInfoTabControls.CommercialRecordNumber?.errors) }" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CommercialRecordNumber?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialRecordNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialRecordNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialRecordNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!--COMMERCIAL_RECORD_COPY Uploder-->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value != 2">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMMERCIAL_RECORD_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && commericalRecordCopyAttachment != null">
              <a id="uploaderCommericalRecordCopyURL" [attr.href]="uploadUrl + commericalRecordCopyAttachment?.URL"
                target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="CommericalRecordCopy" id="uploaderCommericalRecordCopy"
                class="form-control" name="uploaderCommericalRecordCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.CommericalRecordCopy, 'SupplierRegistration_CommericalRecord', 'commericalRecordCopyProgress', i, true, false, false, getAttachmentType.SupplierCommericalRecord, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMMERCIAL_RECORD_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="commericalRecordCopyProgress + '%'">
                  <span class=""> {{commericalRecordCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CommericalRecordCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.CommericalRecordCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getBasicSupplierInfoTabControls?.CommericalRecordCopy?.errors && 
                            !getBasicSupplierInfoTabControls?.CommericalRecordCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- COMMERCIAL_RECORD_EXPIRY_DATE DatePicker -->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value != 2">
            <label
              for="dpCommercialRecordExpiryDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMMERCIAL_RECORD_EXPIRY_DATE' | translate}}</label>
            <span class="red"> *</span>
            <input formControlName="CommercialRecordExpiryDate" id="dpCommercialRecordExpiryDate" class="form-control"
              placeholder="{{datePlaceHolder}}" name="dpCommercialRecordExpiryDate" #datepickerYMD="bsDatepicker"
              bsDatepicker formControlName="CommercialRecordExpiryDate"
              [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.CommercialRecordExpiryDate?.dirty  && getBasicSupplierInfoTabControls.CommercialRecordExpiryDate.errors) }">
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CommercialRecordExpiryDate?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.CommercialRecordExpiryDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="getBasicSupplierInfoTabControls.CommercialRecordExpiryDate?.errors?.inValidDateError && !getBasicSupplierInfoTabControls?.CommercialRecordExpiryDate?.errors?.required">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- INDUSTRIAL_REGISTRATION_NUMBER Text-->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 2">
            <label
              for="txtIndustrialRegistrationNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.INDUSTRIAL_REGISTRATION_NUMBER' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="IndustrialRegistrationNumber" id="txtIndustrialRegistrationNumber"
              class="form-control" name="txtIndustrialRegistrationNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.IndustrialRegistrationNumber?.dirty && getBasicSupplierInfoTabControls.IndustrialRegistrationNumber?.errors) }" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.IndustrialRegistrationNumber?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.IndustrialRegistrationNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.IndustrialRegistrationNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.IndustrialRegistrationNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- TAX_RECORD_NUMBER Text-->
          <div class="form-group">
            <!-- <label for="txtTaxRecordNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_RECORD_NUMBER' | translate}}</label> -->
            <!-- Consider Tax Record Number as Tax Card Number in UI -->
            <label for="txtTaxCardNumber"> {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_CARD_NUMBER' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="TaxRecordNumber" id="txtTaxRecordNumber" class="form-control"
              name="txtTaxRecordNumber" (change)="TaxRecordNumberChange($event)"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.TaxRecordNumber?.dirty && getBasicSupplierInfoTabControls.TaxRecordNumber?.errors) }" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.TaxRecordNumber?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxRecordNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxRecordNumber?.errors?.pattern">
                {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_RECORD_NUMBER_FORMAT_VALIDATION' | translate}}
                <div>#######-######-#####</div>
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxRecordNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="isTaxRecordNumberDuplicated">
                {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_RECORD_NUMBER_DUPLICATE_VALIDATION' | translate}}
              </div>
            </div>
          </div>
          <!-- TAX_CARD_NUMBER Text-->
          <!-- <div class="form-group">
            <label for="txtTaxCardNumber">
              {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_CARD_NUMBER' | translate}}
            </label>
            <span class="red">*</span>
            <input type="text" formControlName="TaxCardNumber" id="txtTaxCardNumber" class="form-control"
              name="txtTaxCardNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.TaxCardNumber?.dirty && getBasicSupplierInfoTabControls.TaxCardNumber?.errors) }" />
            <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.TaxCardNumber?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardNumber?.errors?.pattern">
                {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_RECORD_NUMBER_FORMAT_VALIDATION' | translate}}
                <div>#######-######-#####</div>
              </div>
            </div>
          </div> -->
          <!-- TAX_CARD_COPY Uploder-->
          <div class="form-group ">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_CARD_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add">
              <a id="uploaderTaxCardCopyURL" [attr.href]="uploadUrl + taxCardCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <!--(event, currFormControl, docName, progressVariableName, index?, isBasicInfo?:boolean, isCategory?:boolean, isPartner?:boolean, attachmentType?: AttachmentType)-->
              <input type="file" formControlName="TaxCardCopy" id="uploaderTaxCardCopy" class="form-control"
                name="uploaderTaxCardCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.TaxCardCopy, 'SupplierRegistration_TaxCardCopy', 'taxCardCopyProgress', i, true, false, false, getAttachmentType.SupplierTaxCard,'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_CARD_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="taxCardCopyProgress + '%'">
                  <span class=""> {{taxCardCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.TaxCardCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="!getBasicSupplierInfoTabControls?.TaxCardCopy?.errors &&
                            getBasicSupplierInfoTabControls?.TaxCardCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- TAX_CARD_EXPIRY_DATE DatePicker -->
          <div class="form-group">
            <label
              for="dpTaxCardExpiryDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_CARD_EXPIRY_DATE' | translate}}</label>
            <span class="red"> *</span>
            <input formControlName="TaxCardExpiryDate" id="dpTaxCardExpiryDate" class="form-control"
              placeholder="{{datePlaceHolder}}" name="dpTaxCardExpiryDate" #datepickerYMD="bsDatepicker" bsDatepicker
              [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.TaxCardExpiryDate?.dirty  && getBasicSupplierInfoTabControls.TaxCardExpiryDate.errors) }">
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.TaxCardExpiryDate?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxCardExpiryDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="getBasicSupplierInfoTabControls?.TaxCardExpiryDate?.errors?.inValidDateError && !getBasicSupplierInfoTabControls?.TaxCardExpiryDate?.errors?.required">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- TAX_AUTHORITY Text-->
          <div class="form-group">
            <label
              for="txtTaxAuthority">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_AUTHORITY' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="TaxAuthority" id="txtTaxAuthority" class="form-control"
              name="txtTaxAuthority"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.TaxAuthority?.dirty && getBasicSupplierInfoTabControls.TaxAuthority?.errors) }" />
            <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.TaxAuthority?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxAuthority.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxAuthority.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.TaxAuthority.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- VAT Registration Check -->
          <div class ="form-group">
            <label id="example-radio-group-label">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.VAT_CHECK' | translate}}</label>
              <div class="custom-Radio">
                <input id="chkVATRegCheckYes"  type="radio"  name="VATRegCheck" value="true" formControlName="VATRegCheck" (change)="VATRegCheck($event)"/>
                <label for="chkVATRegCheckYes">{{'SHARED.Yes' | translate}}</label>
                </div>
                <div class="custom-Radio">
                <input id="chkVATRegCheckNo"  type="radio"  name="VATRegCheck" value="false" formControlName="VATRegCheck" (change)="VATRegCheck($event)"/>
                <label for="chkVATRegCheckNo">{{'SHARED.No' | translate}}</label>
              </div>
          </div>
           <!-- VAT_NUMBER Text-->
           <div *ngIf="getBasicSupplierInfoTabControls?.VATRegCheck?.value == 'true'" class="form-group">
            <label
              for="txtVATNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.VAT_NUMBER' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="VATNumber" id="txtVATNumber" class="form-control" name="txtVATNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.VATNumber?.dirty && getBasicSupplierInfoTabControls.VATNumber?.errors) }" />
            <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.VATNumber?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls?.VATNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.VATNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.VATNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.VATNumber?.errors?.pattern">
                {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.TAX_RECORD_NUMBER_FORMAT_VALIDATION' | translate}}
                <div>#######-######-#####</div>
              </div>
            </div>
          </div>
          <!-- VAT_REGISTRAION_DATE DatePicker -->
          <div *ngIf="getBasicSupplierInfoTabControls?.VATRegCheck?.value == 'true'" class="form-group">
            <label
              for="dpVATRegistrationDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.VAT_REGISTRAION_DATE' | translate}}</label>
            <span class="red"> *</span>
            <input formControlName="VATRegistrationDate" id="dpVATRegistrationDate" class="form-control"
              placeholder="{{datePlaceHolder}}" name="dpVATRegistrationDate" [minDate]="null" [maxDate]="getTodayDate"
              #datepickerYMD="bsDatepicker" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.VATRegistrationDate?.dirty  && getBasicSupplierInfoTabControls.VATRegistrationDate.errors) }">
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.VATRegistrationDate?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.VATRegistrationDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="getBasicSupplierInfoTabControls.VATRegistrationDate?.errors?.inValidDateError && !getBasicSupplierInfoTabControls?.VATRegistrationDate?.errors?.required">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- VAT_REGISTRATION_COPY Uploder-->
          <div *ngIf="getBasicSupplierInfoTabControls?.VATRegCheck?.value == 'true'" class="form-group">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.VAT_REGISTRATION_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add">
              <a *ngIf="vatRegistrationCopyAttachment" id="uploaderVATRegistrationCopyURL" [attr.href]="uploadUrl + vatRegistrationCopyAttachment?.URL"
                target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="VATRegistrationCopy" id="uploaderVATRegistrationCopy"
                class="form-control" name="uploaderVATRegistrationCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.VATRegistrationCopy, 'SupplierRegistration_VATRegistration', 'vatRegistrationCopyProgress', i, true, false, false, getAttachmentType.SupplierVATRegisteration, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.VAT_REGISTRATION_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="vatRegistrationCopyProgress + '%'">
                  <span class=""> {{vatRegistrationCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.VATRegistrationCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.VATRegistrationCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getBasicSupplierInfoTabControls?.VATRegistrationCopy?.errors &&
                            !getBasicSupplierInfoTabControls?.VATRegistrationCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- PUBLICATION_IN_THE_OFFICIAL_GAZETTE_COPY Uploder-->
          <div class="form-group" *ngIf="(formMode == FormMode.Add || formMode == FormMode.Edit) || 
                                         ((formMode == FormMode.Readonly || formMode == FormMode.AdminEdit) && 
                                            publicationOfficialGazetteCopyAttachment != null)">
            <label>
              {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.PUBLICATION_IN_THE_OFFICIAL_GAZETTE_COPY' | translate}}</label>
            <!-- <span class="red"> *</span> -->
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && publicationOfficialGazetteCopyAttachment != null">
              <a id="uploaderPublicationOfficialGazetteCopyURL"
                [attr.href]="uploadUrl + publicationOfficialGazetteCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="PublicationOfficialGazetteCopy"
                id="uploaderPublicationOfficialGazetteCopy" class="form-control"
                name="uploaderPublicationOfficialGazetteCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.PublicationOfficialGazetteCopy, 'SupplierRegistration_PublicationOfficialGazette', 'publicationOfficialGazetteCopyProgress', i, true, false, false, getAttachmentType.SupplierPublicationInTheOfficialGazette, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.PUBLICATION_IN_THE_OFFICIAL_GAZETTE_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="publicationOfficialGazetteCopyProgress + '%'">
                  <span class=""> {{publicationOfficialGazetteCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.PublicationOfficialGazetteCopy?.invalid"
                class="red">
                <!-- <div *ngIf="getBasicSupplierInfoTabControls?.PublicationOfficialGazetteCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div> -->

                <div *ngIf="getBasicSupplierInfoTabControls?.PublicationOfficialGazetteCopy?.errors">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>

              </div>
            </div>
          </div>
          <!-- ACTIVITY_LEGAL_RECORD_REGISTRATION_NUMBER Text-->
          <div class="form-group">
            <label
              for="txtActivityLegalRecordRegisterationNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.ACTIVITY_LEGAL_RECORD_REGISTRATION_NUMBER' | translate}}</label>
            <!-- <span class="red">*</span> -->
            <input type="text" formControlName="ActivityLegalRecordRegistrationNumber"
              id="txtActivityLegalRecordRegisterationNumber" class="form-control"
              name="txtActivityLegalRecordRegisterationNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.ActivityLegalRecordRegistrationNumber?.dirty && getBasicSupplierInfoTabControls.ActivityLegalRecordRegistrationNumber?.errors) }" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationNumber?.invalid"
              class="red">
              <!-- <div *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div
                *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- ACTIVITY_LEGAL_RECORD_REGISTRATION_COPY Uploder-->
          <div class="form-group" *ngIf="(formMode == FormMode.Add || formMode == FormMode.Edit) || 
                                  ((formMode == FormMode.Readonly || formMode == FormMode.AdminEdit) && 
                                  activityLegalRegistrationCopyAttachment != null)">
            <label>
              {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.ACTIVITY_LEGAL_RECORD_REGISTRATION_COPY' | translate}}</label>
            <!-- <span class="red"> *</span> -->
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && activityLegalRegistrationCopyAttachment != null">
              <a id="uploaderActivityLegalRegistrationCopyURL"
                [attr.href]="uploadUrl + activityLegalRegistrationCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="ActivityLegalRegistrationCopy"
                id="uploaderActivityLegalRegistrationCopy" class="form-control"
                name="uploaderActivityLegalRegistrationCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.ActivityLegalRegistrationCopy, 'SupplierRegistration_ActivityLegalRegistration', 'activityLegalRegistrationCopyProgress', i, true, false, false, getAttachmentType.SupplierActivityLegalRecordRegistration, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.ACTIVITY_LEGAL_RECORD_REGISTRATION_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="activityLegalRegistrationCopyProgress + '%'">
                  <span class=""> {{activityLegalRegistrationCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ActivityLegalRegistrationCopy?.invalid"
                class="red">
                <!-- <div *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRegistrationCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div> -->
                <div *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRegistrationCopy?.errors">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- ACTIVITY_LEGAL_RECORD_REGISTRATION_DATE DatePicker -->
          <div class="form-group">
            <label
              for="dpActivityLegalRecordRegistrationDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.ACTIVITY_LEGAL_RECORD_REGISTRATION_DATE' | translate}}</label>
            <!-- <span class="red"> *</span> -->
            <input formControlName="ActivityLegalRecordRegistrationDate" id="dpActivityLegalRecordRegistrationDate"
              class="form-control" placeholder="{{datePlaceHolder}}" name="dpActivityLegalRecordRegistrationDate"
              [minDate]="null" [maxDate]="getTodayDate" #datepickerYMD="bsDatepicker" bsDatepicker
              [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.ActivityLegalRecordRegistrationDate?.dirty  && getBasicSupplierInfoTabControls.ActivityLegalRecordRegistrationDate.errors) }">
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationDate?.invalid"
              class="red ">
              <!-- <div *ngIf="getBasicSupplierInfoTabControls.ActivityLegalRecordRegistrationDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div
                *ngIf="getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationDate?.errors?.inValidDateError && !getBasicSupplierInfoTabControls?.ActivityLegalRecordRegistrationDate?.errors?.required">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- CLIENTS_ENTITIES_PREVIOUS_WORKS_COPY Uploder-->
          <div class="form-group" *ngIf="(formMode == FormMode.Add || formMode == FormMode.Edit) || 
                                        ((formMode == FormMode.Readonly || formMode == FormMode.AdminEdit) && 
                                        clientsEntitiesPreviousWorksCopyAttachment != null)">
            <label>
              {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.CLIENTS_ENTITIES_PREVIOUS_WORKS_COPY' | translate}}</label>
            <!-- <span class="red"> *</span> -->
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && clientsEntitiesPreviousWorksCopyAttachment != null">
              <a id="uploaderClientsEntitiesPreviousWorksCopyURL"
                [attr.href]="uploadUrl + clientsEntitiesPreviousWorksCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="ClientsEntitiesPreviousWorksCopy"
                id="uploaderClientsEntitiesPreviousWorksCopy" class="form-control"
                name="uploaderClientsEntitiesPreviousWorksCopy" MaxSizeInMB="50"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.ClientsEntitiesPreviousWorksCopy, 'SupplierRegistration_ClientsEntitiesPreviousWorks', 'clientsEntitiesPreviousWorksCopyProgress', i, true, false, false, getAttachmentType.SupplierClientsEntitesPreviousWorks, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.CLIENTS_ENTITIES_PREVIOUS_WORKS_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <!-- <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span> -->
                <span>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.ExperienceMaxFileSize' | translate}}</span>
              </div>
              <div class="upload-info">
                <span>
                  {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.CLIENTS_ENTITIES_PREVIOUS_WORKS_COPY_DESCRIPTION' | translate}}
                </span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="clientsEntitiesPreviousWorksCopyProgress + '%'">
                  <span class=""> {{clientsEntitiesPreviousWorksCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ClientsEntitiesPreviousWorksCopy?.invalid"
                class="red">
                <!-- <div *ngIf="getBasicSupplierInfoTabControls?.ClientsEntitiesPreviousWorksCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div> -->
                <div *ngIf="getBasicSupplierInfoTabControls?.ClientsEntitiesPreviousWorksCopy?.errors">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- PAIED_CAPITAL Text-->
          <div class="form-group">
            <label
              for="txtPaidCapital">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.PAIED_CAPITAL' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="PaidCapital" id="txtPaidCapital" class="form-control"
              name="txtPaidCapital"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.PaidCapital?.dirty && getBasicSupplierInfoTabControls.PaidCapital?.errors) }" />
            <div *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.PaidCapital?.invalid"
              class="red">
              <div *ngIf="getBasicSupplierInfoTabControls.PaidCapital.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.PaidCapital?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.PaidCapital?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- COMPANY_ESTABLISHING_DATE DatePicker -->
          <div class="form-group">
            <label
              for="dpCompanyEstablishingDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMPANY_ESTABLISHING_DATE' | translate}}</label>
            <span class="red"> *</span>
            <input formControlName="CompanyEstablishingDate" id="dpCompanyEstablishingDate" class="form-control"
              placeholder="{{datePlaceHolder}}" name="dpCompanyEstablishingDate" [minDate]="null"
              [maxDate]="getTodayDate" #datepickerYMD="bsDatepicker" bsDatepicker
              [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.CompanyEstablishingDate?.dirty  && getBasicSupplierInfoTabControls.CompanyEstablishingDate.errors) }">
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CompanyEstablishingDate?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.CompanyEstablishingDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="getBasicSupplierInfoTabControls?.CompanyEstablishingDate?.errors?.inValidDateError && !getBasicSupplierInfoTabControls?.CompanyEstablishingDate?.errors?.required">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- AVERAGE_ANNUAL_TURNOVER Text + Singel-Select-DDL-->
          <!-- Label will be "Maximum business -الحد الأقصى للأعمال" in case of Supplier Type is "Contractor - مقاول" -->
          <div class="form-group">
            <label *ngIf="getBasicSupplierInfoTabControls.SupplierTypeId.value != 4"
              for="txtAverageAnnualTurnOver">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.AVERAGE_ANNUAL_TURNOVER' | translate}}</label>
            <label *ngIf="getBasicSupplierInfoTabControls.SupplierTypeId.value == 4"
              for="txtAverageAnnualTurnOver">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.MAXIMUM_BUSSINESS' | translate}}</label>
            <!-- <span class="red">*</span> -->
            <div class="split-form-group-units">
              <input type="text" formControlName="AverageAnnualTurnover" id="txtAverageAnnualTurnOver"
                class="form-control" name="txtAverageAnnualTurnOver" (keyup)="onChangeAverageAnnualTurnover($event)">

              <!-- <span class="red"> *</span> -->
              <select formControlName="AverageAnnualTurnoverCurrencyId" id="txtAverageAnnualTurnoverCurrencyId"
                class="form-control" name="txtAverageAnnualTurnoverCurrencyId">
                <option [value]="''" selected>
                  {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                </option>
                <ng-container *ngFor="let currency of currencies">
                  <option *ngIf="currentLanguage == Languages.English" [value]="currency.Id">
                    {{currency.NameEN}}
                  </option>
                  <option *ngIf="currentLanguage == Languages.Arabic" [value]="currency.Id">
                    {{currency.NameAR}}
                  </option>
                </ng-container>
              </select>

            </div>
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && (getBasicSupplierInfoTabControls?.AverageAnnualTurnover?.invalid || getBasicSupplierInfoTabControls?.AverageAnnualTurnoverCurrencyId?.invalid)"
              class="red">
              <!-- <div *ngIf="getBasicSupplierInfoTabControls?.AverageAnnualTurnover?.errors?.required || getBasicSupplierInfoTabControls?.AverageAnnualTurnoverCurrencyId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="getBasicSupplierInfoTabControls?.AverageAnnualTurnoverCurrencyId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.AverageAnnualTurnover?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getBasicSupplierInfoTabControls?.AverageAnnualTurnover?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
            <!-- <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.AverageAnnualTurnoverCurrencyId?.invalid"
                class="red ">
                <div *ngIf="getBasicSupplierInfoTabControls?.AverageAnnualTurnoverCurrencyId?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
              </div> -->
          </div>
          <!-- LAST_TWO_YEARS_BALANCE_SHEET_COPY Uploder-->
          <div class="form-group">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.LAST_TWO_YEARS_BALANCE_SHEET_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add">
              <a id="uploaderLastTwoYearsBalanceSheetCopyURL"
                [attr.href]="uploadUrl + lastTwoYearsBalanceSheetCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="LastTwoYearsBalanceSheetCopy"
                id="uploaderLastTwoYearsBalanceSheetCopy" class="form-control"
                name="uploaderLastTwoYearsBalanceSheetCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.LastTwoYearsBalanceSheetCopy, 'SupplierRegistration_LastTwoYearsBalanceSheet', 'lastTwoYearsBalanceSheetCopyProgress', i, true, false, false, getAttachmentType.SupplierLastTwoYearsBalanceSheet, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.LAST_TWO_YEARS_BALANCE_SHEET_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="lastTwoYearsBalanceSheetCopyProgress + '%'">
                  <span class=""> {{lastTwoYearsBalanceSheetCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.LastTwoYearsBalanceSheetCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.LastTwoYearsBalanceSheetCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getBasicSupplierInfoTabControls?.LastTwoYearsBalanceSheetCopy?.errors &&
                            !getBasicSupplierInfoTabControls?.LastTwoYearsBalanceSheetCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- COMPANY_CONTRACT_COPY Uploder-->
          <div class="form-group" *ngIf="(formMode == FormMode.Add || formMode == FormMode.Edit) || 
          ((formMode == FormMode.Readonly || formMode == FormMode.AdminEdit) && 
          companyContractCopyAttachment != null)">
            <label>
              {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMPANY_CONTRACT_COPY' | translate}}</label>
            <!-- <span class="red"> *</span> -->
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && companyContractCopyAttachment != null">
              <a id="uploaderCompanyContractCopyURL" [attr.href]="uploadUrl + companyContractCopyAttachment?.URL"
                target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="CompanyContractCopy" id="uploaderCompanyContractCopy"
                class="form-control" name="uploaderCompanyContractCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.CompanyContractCopy, 'SupplierRegistration_CompanyContract', 'companyContractCopyProgress', i, true, false, false, getAttachmentType.SupplierCompanyContract, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMPANY_CONTRACT_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="companyContractCopyProgress + '%'">
                  <span class=""> {{companyContractCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.CompanyContractCopy?.invalid"
                class="red">
                <!-- <div *ngIf="getBasicSupplierInfoTabControls?.CompanyContractCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div> -->
                <div *ngIf="getBasicSupplierInfoTabControls?.CompanyContractCopy?.errors &&
                            !getBasicSupplierInfoTabControls?.CompanyContractCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- CONSTRUCTION_NUMBER Text-->
          <div class="form-group" *ngIf="getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 4">
            <label
              for="txtConstructionNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONSTRUCTION_NUMBER' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="ConstructionNumber" id="txtConstructionNumber" class="form-control"
              name="txtConstructionNumber"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getBasicSupplierInfoTabControls.ConstructionNumber?.dirty && getBasicSupplierInfoTabControls.ConstructionNumber?.errors) }" />
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ConstructionNumber?.invalid"
              class="red">
              <div *ngIf=" getBasicSupplierInfoTabControls?.ConstructionNumber?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf=" getBasicSupplierInfoTabControls?.ConstructionNumber?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
              <div *ngIf=" getBasicSupplierInfoTabControls?.ConstructionNumber?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- CONTRACTOR_CATEGORY Singel-Select-DDL-->
          <div class="form-group" *ngIf="getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 4">
            <label
              for="ddlContractorCategory">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CATEGORY' | translate}}</label>
            <span class="red"> *</span>
            <select formControlName="ContractorCategoryId" id="ddlContractorCategory" class="form-control"
              name="ddlContractorCategory">
              <option [value]="''" selected>
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
              </option>
              <!-- <option [value]="1">Contractor Category 1</option>
                                      <option [value]="2">Contractor Category 2</option>
                                      <option [value]="3">Contractor Category 3</option> -->
              <ng-container *ngFor="let contractorCategory of contractorCategories">
                <option *ngIf="currentLanguage == Languages.English" [value]="contractorCategory.Id">
                  {{contractorCategory.NameEN}}
                </option>
                <option *ngIf="currentLanguage == Languages.Arabic" [value]="contractorCategory.Id">
                  {{contractorCategory.NameAR}}
                </option>
              </ng-container>
            </select>
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ContractorCategoryId?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.ContractorCategoryId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
          <!-- CONTRACTOR_CATEGORY_COPY Uploder-->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 4">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CATEGORY_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add && contructorCategoryCopyAttachment != null">
              <a id="uploaderContructorCategoryCopyURL" [attr.href]="uploadUrl + contructorCategoryCopyAttachment?.URL"
                target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="ContructorCategoryCopy" id="uploaderContructorCategoryCopy"
                class="form-control" name="uploaderContructorCategoryCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.ContructorCategoryCopy, 'SupplierRegistration_ConstructorCategory', 'contructorCategoryCopyProgress', i, true, false, false, getAttachmentType.SupplierConstructorCategory, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CATEGORY_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="contructorCategoryCopyProgress + '%'">
                  <span class=""> {{contructorCategoryCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ContructorCategoryCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.ContructorCategoryCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getBasicSupplierInfoTabControls?.ContructorCategoryCopy?.errors &&
                            !getBasicSupplierInfoTabControls?.ContructorCategoryCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- CONTRACTOR_CLASSIFICATION Singel-Select-DDL-->
          <div class="form-group" *ngIf="getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 4">
            <label
              for="ddlContractorClassificationId">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CLASSIFICATION' | translate}}</label>
            <span class="red"> *</span>
            <select formControlName="ContractorClassificationId" id="ddlContractorClassificationId" class="form-control"
              name="ddlContractorClassificationId">
              <option [value]="''" selected>
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
              </option>
              <!-- <option [value]="1">Contractor Classification 1</option>
                                      <option [value]="2">Contractor Classification 2</option>
                                      <option [value]="3">Contractor Classification 3</option> -->
              <ng-container *ngFor="let contractorClassification of contractorClassifications">
                <option *ngIf="currentLanguage == Languages.English" [value]="contractorClassification.Id">
                  {{contractorClassification.NameEN}}
                </option>
                <option *ngIf="currentLanguage == Languages.Arabic" [value]="contractorClassification.Id">
                  {{contractorClassification.NameAR}}
                </option>
              </ng-container>
            </select>
            <div
              *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ContractorClassificationId?.invalid"
              class="red ">
              <div *ngIf="getBasicSupplierInfoTabControls?.ContractorClassificationId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
          <!-- CONTRACTOR_CLASSIFICATION_COPY Uploder-->
          <div class="form-group"
            *ngIf="!getBasicSupplierInfoTabControls?.SupplierTypeId?.invalid && getBasicSupplierInfoTabControls?.SupplierTypeId?.value == 4">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CLASSIFICATION_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded"
              *ngIf="formMode != FormMode.Add && contructorClassificationCopyAttachment != null">
              <a id="uploaderContructorClassificationCopyURL"
                [attr.href]="uploadUrl + contructorClassificationCopyAttachment?.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="ContructorClassificationCopy"
                id="uploaderContructorClassificationCopy" class="form-control"
                name="uploaderContructorClassificationCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getBasicSupplierInfoTabControls.ContructorClassificationCopy, 'SupplierRegistration_ConstructorClassification', 'contructorClassificationCopyProgress', i, true, false, false, getAttachmentType.SupplierConstructorClassification, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.CONTRACTOR_SUPPLIER_INFO_TAB.CONTRACTOR_CLASSIFICATION_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="contructorClassificationCopyProgress + '%'">
                  <span class=""> {{contructorClassificationCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabOneSubmitted || formSubmitted) && getBasicSupplierInfoTabControls?.ContructorClassificationCopy?.invalid"
                class="red">
                <div *ngIf="getBasicSupplierInfoTabControls?.ContructorClassificationCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getBasicSupplierInfoTabControls?.ContructorClassificationCopy?.errors &&
                            !getBasicSupplierInfoTabControls?.ContructorClassificationCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Next -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">
            {{ 'FRONT_USER.NEXT' | translate}}
          </button>
        </p>
      </tab>
      <!---SUPPLIER_BANKS_INFO TAB-->
      <tab #supplierBanksTab [disabled]="disableTabs"
        heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_BANKS_INFO' | translate}}">
        <div formArrayName="SupplierBanks">
          <div *ngFor="let bank of getFormControls.SupplierBanks.controls; let i=index; let last = last"
            [formGroupName]="i">
            <div class="form-container">
              <!-- BANK_NAME Singel-Select-DDL-->
              <div class="form-group">
                <label
                  for="ddlBankId">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_BANKS_INFO_TAB.BANK_NAME' | translate}}</label>
                <span class="red">*</span>
                <!-- <input type="text" formControlName="BankName" id="txtBankName" class="form-control" name="txtBankName"
                  [ngClass]="{'is-invalid':formSubmitted ||( bank.get('BankName')?.dirty && bank.get('BankName')?.errors) }" /> -->

                <select formControlName="BankId" id="ddlBankId" class="form-control" name="ddlBankId">
                  <option [value]="''" selected>
                    {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                  </option>
                  <ng-container *ngFor="let bank of banks">
                    <option *ngIf="currentLanguage == Languages.English" [value]="bank.Id">
                      {{bank.NameEN}}
                    </option>
                    <option *ngIf="currentLanguage == Languages.Arabic" [value]="bank.Id">
                      {{bank.NameAR}}
                    </option>
                  </ng-container>
                </select>

                <div *ngIf="(isTabTwoSubmitted || formSubmitted) &&  bank?.get('BankId')?.invalid" class="red">
                  <div *ngIf="bank?.get('BankId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <!-- <div *ngIf="bank?.get('BankName')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                  <div *ngIf="bank?.get('BankName')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div> -->
                </div>
              </div>
              <!-- BANK_BRANCH Text-->
              <div class="form-group">
                <label
                  for="txtBankBranch">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_BANKS_INFO_TAB.BANK_BRANCH' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="BankBranch" id="txtBankBranch" class="form-control"
                  name="txtBankBranch"
                  [ngClass]="{'is-invalid':formSubmitted ||( bank.get('BankBranch')?.dirty && bank.get('BankBranch')?.invalid) }" />
                <div *ngIf="(isTabTwoSubmitted || formSubmitted) &&  bank?.get('BankBranch')?.invalid" class="red">
                  <div *ngIf="bank?.get('BankBranch')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="bank?.get('BankBranch')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                  <div *ngIf="bank?.get('BankBranch')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>
              <!-- ACCOUNT_NUMBER Text-->
              <div class="form-group">
                <label
                  for="txtAccountNumber">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_BANKS_INFO_TAB.ACCOUNT_NUMBER' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="AccountNumber" id="txtAccountNumber" class="form-control"
                  name="txtAccountNumber"
                  [ngClass]="{'is-invalid':formSubmitted ||( bank.get('AccountNumber')?.dirty && bank.get('AccountNumber')?.errors) }" />
                <div *ngIf="(isTabTwoSubmitted || formSubmitted) &&  bank?.get('AccountNumber')?.invalid" class="red">
                  <div *ngIf="bank?.get('AccountNumber')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="bank?.get('AccountNumber')?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                  <!-- <div *ngIf="bank?.get('AccountNumber')?.errors?.maxlength">
                    {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_BANKS_INFO_TAB.ACCOUNT_NUMBER_VALIDATION' | translate}}
                  </div>
                  <div *ngIf="bank?.get('AccountNumber')?.errors?.minlength">
                    {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_BANKS_INFO_TAB.ACCOUNT_NUMBER_VALIDATION' | translate}}
                  </div> -->
                </div>
              </div>
            </div>
            <!-- DELETE_BUTTON Button-->
            <p class="btns-holder"
              *ngIf="formMode != FormMode.AdminEdit && formMode != FormMode.Readonly && getFormControls.SupplierBanks.controls.length > 1">
              <!-- <button class="btn SCAcustomBtn" type="button" (click)="DeleteSupplierBank(i)">
                {{'FRONT_USER.DELETE' | translate }}
              </button> -->
              <button class="btn SCAcustomBtn" type="button" Confirmation (confirmationClick)="DeleteSupplierBank(i)">
                {{'FRONT_USER.DELETE' | translate }}
              </button>
            </p>

            <!-- ADD_BUTTON Button-->
            <p *ngIf="formMode != FormMode.AdminEdit && last && formMode!= FormMode.Readonly" class="btns-holder">
              <!-- <button type="button" class="btn SCAcustomBtn" (click)="AddSupplierBank()">
                {{'FRONT_USER.ADD' | translate}}
              </button> -->
              <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="AddSupplierBank()">
                {{'FRONT_USER.ADD' | translate}}
              </button>
            </p>
            <hr />
          </div>
        </div>
        <!-- Next-Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(2) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---SUPPLIER_CONTACT_INFO TAB-->
      <tab #contactInfoTab [disabled]="disableTabs"
        heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_CONTACT_INFO' | translate}}">
        <div class="form-container" formGroupName="ContactInfoTab">
          <!---ADDRESS Text-->
          <div class="form-group">
            <label for="txtAddress">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.ADDRESS' | translate}}</label>
            <span class="red">*</span>
            <textarea formControlName="Address" id="txtAddress" class="form-control" name="txtAddress"></textarea>
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.Address?.invalid"
              class="red">
              <div *ngIf="getContactInfoTabControls?.Address?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.Address?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_500_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.Address?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- POSTAL_CODE Text-->
          <div class="form-group">
            <label
              for="txtPostalCode">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CONTACT_INFO_TAB.POSTAL_CODE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="PostalCode" id="txtPostalCode" class="form-control" name="txtPostalCode"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getContactInfoTabControls.PostalCode?.dirty && getContactInfoTabControls.PostalCode?.errors) }" />
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.PostalCode?.invalid"
              class="red">
              <div *ngIf="getContactInfoTabControls?.PostalCode?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.PostalCode?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.PostalCode?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- GOVERNORATE Singel-Select-DDL-->
          <div class="form-group">
            <label
              for="ddlGovernorate">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CONTACT_INFO_TAB.GOVERNORATE' | translate}}</label>
            <span class="red"> *</span>
            <select formControlName="GovernorateId" id="ddlGovernorate" class="form-control" name="ddlGovernorate">
              <option [value]="''" selected>
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
              </option>
              <ng-container *ngFor="let governorate of governorates">
                <option *ngIf="currentLanguage == Languages.English" [value]="governorate.Id">
                  {{governorate.NameEN}}
                </option>
                <option *ngIf="currentLanguage == Languages.Arabic" [value]="governorate.Id">
                  {{governorate.NameAR}}
                </option>
              </ng-container>
            </select>
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.GovernorateId?.invalid"
              class="red ">
              <div *ngIf="getContactInfoTabControls?.GovernorateId?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
          <!-- CONTACT_PERSON_NAME Text-->
          <div class="form-group">
            <label
              for="txtContactPersonName">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CONTACT_PERSON_NAME' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="ContactPersonName" id="txtContactPersonName" class="form-control"
              name="txtContactPersonName"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getContactInfoTabControls.ContactPersonName?.dirty && getContactInfoTabControls.ContactPersonName?.errors) }" />
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.ContactPersonName?.invalid"
              class="red">
              <div *ngIf="getContactInfoTabControls?.ContactPersonName?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.ContactPersonName?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.ContactPersonName?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- CONTACT_PERSON_ID_COPY Uploder-->
          <div class="form-group">
            <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CONTACT_INFO_TAB.CONTACT_PERSON_ID_COPY' | translate}}</label>
            <span class="red"> *</span>
            <div class="read-uploaded" *ngIf="formMode != FormMode.Add">
              <a id="uploaderContactPersonIDCopyURL" [attr.href]="uploadUrl + contactPersonIDCopyAttachment?.URL"
                target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>
            <div *ngIf="formMode != FormMode.Readonly && formMode != FormMode.AdminEdit">
              <!-- Uploder -->
              <input type="file" formControlName="ContactPersonIDCopy" id="uploaderContactPersonIDCopy"
                class="form-control" name="uploaderContactPersonIDCopy" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="AddAttachmentFile($event, getContactInfoTabControls.ContactPersonIDCopy, 'SupplierRegistration_ContactPersonID', 'contactPersonIDCopyProgress', i, true, false, false, getAttachmentType.SupplierContactPersonID, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CONTACT_INFO_TAB.CONTACT_PERSON_ID_COPY')" />
              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>
              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="contactPersonIDCopyProgress + '%'">
                  <span class=""> {{contactPersonIDCopyProgress}} % Complete</span>
                </div>
              </div>
              <!-- Required validate Message -->
              <div
                *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.ContactPersonIDCopy?.invalid"
                class="red">
                <div *ngIf="getContactInfoTabControls?.ContactPersonIDCopy?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="getContactInfoTabControls?.ContactPersonIDCopy?.errors && 
                        !getContactInfoTabControls?.ContactPersonIDCopy?.errors?.required">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- PHONE Text-->
          <div class="form-group">
            <label for="txtPhone">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.PHONE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="Phone" id="txtPhone" class="form-control" name="txtPhone"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getContactInfoTabControls.Phone?.dirty && getContactInfoTabControls.Phone?.errors) }" />
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.Phone?.invalid"
              class="red">
              <div *ngIf="getContactInfoTabControls?.Phone?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.Phone?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.Phone?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_11_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- FAX Text-->
          <div class="form-group">
            <label for="txtFax">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.FAX' | translate}}</label>
            <!-- <span class="red">*</span> -->
            <input type="text" formControlName="Fax" id="txtFax" class="form-control" name="txtFax"
              [ngClass]="{ 'is-invalid': formSubmitted ||(getContactInfoTabControls.Fax?.dirty && getContactInfoTabControls.Fax?.errors) }" />
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.Fax?.invalid" class="red">
              <!-- <div *ngIf="getContactInfoTabControls?.Fax?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="getContactInfoTabControls?.Fax?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.Fax?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- CONTACT_PERSON_EMAIL Text-->
          <div class="form-group">
            <label
              for="txtContactPersonEmail">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CONTACT_PERSON_EMAIL' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="ContactPersonEmail" id="txtContactPersonEmail" class="form-control"
              name="txtContactPersonEmail" />
            <div
              *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.ContactPersonEmail?.invalid"
              class="red">
              <div *ngIf="getContactInfoTabControls?.ContactPersonEmail?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.ContactPersonEmail?.errors?.pattern">
                {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.ContactPersonEmail?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.ContactPersonEmail?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- WEBSITE_URL Text-->
          <div class="form-group">
            <label
              for="txtWebSiteURL">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CONTACT_INFO_TAB.WEBSITE_URL' | translate}}</label>
            <!-- <span class="red">*</span> -->
            <input type="url" formControlName="WebSiteURL" id="txtWebSiteURL" class="form-control"
              name="txtWebSiteURL" />
            <div *ngIf="(isTabThreeSubmitted || formSubmitted) && getContactInfoTabControls?.WebSiteURL?.invalid"
              class="red">
              <!-- <div *ngIf="getContactInfoTabControls?.WebSiteURL?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="getContactInfoTabControls?.WebSiteURL?.errors?.pattern">
                {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.WEBSITE_ERROR' | translate}}
              </div>
              <div *ngIf="getContactInfoTabControls?.WebSiteURL?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
        </div>
        <!-- Next-Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(1)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(3) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---SUPPLIER_CATEGORIES TAB-->
      <tab #supplierSpecialitiesTab [disabled]="disableTabs"
        heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_CATEGORIES' | translate}}">
        <div formArrayName="SupplierSpecialities" class="form-container">
          <!--formGroupName="SupplierSpecialitiesTab"-->
          <div
            *ngFor="let supplierSpeciality of getFormControls.SupplierSpecialities.controls; let i=index; let last = last"
            [formGroupName]="i">
            <div class="form-container">
              <!-- CATEGORY Singel-Select-DDL-->
              <div class="form-group">
                <label for="ddlCategory">
                  {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CATEGORY' | translate}}
                </label>
                <span class="red"> *</span>
                <!-- <select formControlName="CategoryId" (change)="onCategoryChange($event,i)" id="ddlCategory"
                  class="form-control" name="ddlCategory">
                  <option [value]="''" selected>
                    {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                  </option>
                  <ng-container *ngFor="let category of categories">
                    <option *ngIf="currentLanguage == Languages.English" [value]="category.Id">
                      {{category.NameEN}}
                    </option>
                    <option *ngIf="currentLanguage == Languages.Arabic" [value]="category.Id">
                      {{category.NameAR}}
                    </option>
                  </ng-container>
                </select> -->
                <ng-multiselect-dropdown id="ddlCategory" formControlName ="CategoryId"
                placeholder="{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}"
                [settings]="multiDropDownSettingsCats" [data]="categories" [(ngModel)]="selectedCats[i]"
                [disabled]="formMode == FormMode.Readonly || formMode == FormMode.AdminEdit" (onSelect)="onCategoryChange($event,i)"
                (onDeSelect)="onCategoryDeselect($event,i)">
              </ng-multiselect-dropdown>
                <div *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryId')?.invalid"
                  class="red ">
                  <div *ngIf="supplierSpeciality?.get('CategoryId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                </div>
              </div>
              <!-- SPECIALITY Singel-Select-DDL-->
              <div class="form-group">
                <label for="ddlSpeciality">
                  {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.SPECIALITY' | translate}}
                </label>
                <span class="red"> *</span>
                <select formControlName="SpecialityId" (change)="onSpecialtyChnage($event,i)" id="ddlSpeciality"
                  class="form-control" name="ddlSpeciality">
                  <option [value]="''" selected>
                    {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                  </option>
                  <ng-container
                    *ngFor="let speciality of getCriteria(i ,supplierRegistrationForm.controls['SupplierSpecialities'].controls[i]['controls']['CategoryId']?.value)">
                    <option *ngIf="currentLanguage == Languages.English" [value]="speciality?.Id">
                      {{speciality.NameEN}}
                    </option>
                    <option *ngIf="currentLanguage == Languages.Arabic" [value]="speciality?.Id">
                      {{speciality.NameAR}}
                    </option>
                  </ng-container>
                </select>
                <div *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('SpecialityId')?.invalid"
                  class="red ">

                  <div *ngIf="supplierSpeciality?.get('SpecialityId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                </div>
              </div>
              <!-- CONTACT_PERSON_NAME Text-->
              <div class="form-group">
                <label
                  for="txtCategoryContactPerson">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.CONTACT_PERSON_NAME' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="CategoryContactPerson" id="txtCategoryContactPerson"
                  class="form-control" name="txtCategoryContactPerson"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierSpeciality.get('CategoryContactPerson')?.dirty && supplierSpeciality.get('CategoryContactPerson')?.errors) }" />
                <div
                  *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryContactPerson')?.invalid"
                  class="red ">
                  <div *ngIf="supplierSpeciality?.get('CategoryContactPerson')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryContactPerson')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryContactPerson')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>
              <!-- CONTACT_PERSON_EMAIL Text-->
              <div class="form-group">
                <label
                  for="txtCategoryEmail">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.Email' | translate}}</label>
                <!-- <span class="red">*</span> -->
                <input type="text" formControlName="CategoryEmail" id="txtCategoryEmail" class="form-control"
                  name="txtCategoryEmail"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierSpeciality.get('CategoryEmail')?.dirty && supplierSpeciality.get('CategoryEmail')?.errors) }" />
                <div *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryEmail')?.invalid"
                  class="red ">
                  <!-- <div *ngIf="supplierSpeciality?.get('CategoryEmail')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div> -->
                  <div *ngIf="supplierSpeciality?.get('CategoryEmail')?.errors?.pattern">
                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryEmail')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryEmail')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- FAX Text-->
              <div class="form-group">
                <label
                  for="txtCategoryFax">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.FAX' | translate}}</label>
                <!-- <span class="red">*</span> -->
                <input type="text" formControlName="CategoryFax" id="txtCategoryFax" class="form-control"
                  name="txtCategoryFax"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierSpeciality.get('CategoryFax')?.dirty && supplierSpeciality.get('CategoryFax')?.errors) }" />
                <div *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryFax')?.invalid"
                  class="red ">
                  <!-- <div *ngIf="supplierSpeciality?.get('CategoryFax')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div> -->
                  <div *ngIf="supplierSpeciality?.get('CategoryFax')?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryFax')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- MOBILE Text-->
              <div class="form-group">
                <label
                  for="txtCategoryMobile">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.MOBILE' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="CategoryMobile" id="txtCategoryMobile" class="form-control"
                  name="txtCategoryMobile"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierSpeciality.get('CategoryMobile')?.dirty && supplierSpeciality.get('CategoryMobile')?.errors) }" />
                <div *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryMobile')?.invalid"
                  class="red ">
                  <div *ngIf="supplierSpeciality?.get('CategoryMobile')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryMobile')?.errors?.pattern">
                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryMobile')?.errors?.maxlength">
                    {{'FRONT_USER.MOBILE_VALIDATION' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryMobile')?.errors?.minlength">
                    {{'FRONT_USER.MOBILE_VALIDATION' | translate}}
                  </div>
                </div>
              </div>
              <!-- ADDRESS Text-->
              <!-- <div class="form-group">
                <label
                  for="txtCategoryAddress">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.ADDRESS' | translate}}</label>
                <span class="red">*</span>
                <textarea formControlName="CategoryAddress" id="txtCategoryAddress" class="form-control"
                  name="txtCategoryAddress"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierSpeciality.get('CategoryAddress')?.dirty && supplierSpeciality.get('CategoryAddress')?.errors) }"></textarea>
                <div
                  *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryAddress')?.invalid"
                  class="red ">
                  <div *ngIf="supplierSpeciality?.get('CategoryAddress')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryAddress')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_500_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierSpeciality?.get('CategoryAddress')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div> -->
              <!-- EXPERIENCE Uploder-->
              <div class="form-group">
                <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.EXPERIENCE' | translate}}</label>
                <span class="red"> *</span>
                <div class="read-uploaded"
                  *ngIf="formMode != FormMode.Add && supplierSpeciality['controls']['CategoryExperienceCopyURL'].value != ''">
                  <a id="uploaderCategoryExperienceURL"
                    [attr.href]="uploadUrl + supplierSpeciality['controls']['CategoryExperienceCopyURL'].value"
                    target="_blank">
                    <i class="icon-view-file"></i>
                    {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                  </a>
                </div>
                <div *ngIf="(formMode != FormMode.Readonly && formMode != FormMode.AdminEdit)">
                  <!-- Uploder -->
                  <input type="file" formControlName="CategoryExperience" id="uploaderCategoryExperience"
                    class="form-control" name="uploaderCategoryExperience" MaxSizeInMB="50"
                    accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                    (change)="AddAttachmentFile($event, supplierSpeciality.get('CategoryExperience'), 'SupplierRegistration_CategoryExperience', 'CategoryExperienceProgress', i, false, true, false, null, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.EXPERIENCE')" />
                  <!-- ,.zip,.ZIP,.rar,.RAR -->
                  <!-- Description About File [Size - Allowed EXT.] -->
                  <div class="upload-info">
                    <span>
                      {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.EXPERIENCE_DESCRIPTION' | translate}}
                    </span>
                  </div>
                  <div class="upload-info">
                    <span data-toggle="tooltip"
                      title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">
                      {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.ExperienceAllowedFileExtentions' | translate}}
                    </span>
                    <span>
                      {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.ExperienceMaxFileSize' | translate}}
                    </span>
                  </div>
                  <!-- Progress Bar -->
                  <!-- <div class="progress">
                                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                                    [style.width]="CategoryExperienceProgress + '%'">
                                    <span class=""> {{CategoryExperienceProgress}} % Complete</span>
                                  </div>
                                </div> -->
                  <!-- Required validate Message -->
                  <div
                    *ngIf="(isTabFourSubmitted || formSubmitted) && supplierSpeciality?.get('CategoryExperience')?.invalid"
                    class="red ">
                    <div *ngIf="supplierSpeciality?.get('CategoryExperience')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="supplierSpeciality?.get('CategoryExperience')?.errors &&
                               !supplierSpeciality?.get('CategoryExperience')?.errors?.required">
                      {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Rejection Reason TextArea-->
              <div class="form-group" *ngIf="(filteredSupplierSpicialitiesByCatId[i]?.Status  == 0)">
                <label for="txtCategoryRejectionReason">
                  {{'ADMIN_USER.SUPPPLIER_FORMS.RejectionReason'| translate}}
                </label>
                <textarea *ngIf="filteredSupplierSpicialitiesByCatId[i]?.PurchasingAdminRejectionReason"
                  id="txtCategoryPurchasingRejectionReason" class="form-control"
                  name="txtCategoryPurchasingRejectionReason"
                  value="{{this.filteredSupplierSpicialitiesByCatId[i]?.PurchasingAdminRejectionReason}}"
                  [disabled]="true">
                </textarea>
                <textarea *ngIf="filteredSupplierSpicialitiesByCatId[i]?.TechnicalAdminRejectionReason"
                  id="txtCategoryTechnicalRejectionReason" class="form-control"
                  name="txtCategoryTechnicalRejectionReason"
                  value="{{this.filteredSupplierSpicialitiesByCatId[i]?.TechnicalAdminRejectionReason}}"
                  [disabled]="true">
                </textarea>
                <!-- <textarea id="txtCategoryRejectionReason" class="form-control" name="txtCategoryRejectionReason"
                  value="{{categoryRejectionReason}}">
                </textarea> -->
              </div>
              <div *ngIf="getCategoryTaskStatus(i)" class="form-group">
                <label>
                  {{'SHARED.MY_LONGHAUL_EBOOKING_TASKS.Status'| translate}}
                </label>
                <p>{{getCategoryTaskStatus(i)}}</p>
                <button class="btn btn-primary SCAcustomBtn" (click)="navigateToTask(i)">{{'FRONT_USER.ADMIN_DECISION_FORM.MAKE_DECISION' | translate}}</button>
              </div>
            </div>
            <!-- DELETE_BUTTON Button-->
            <p *ngIf="formMode != FormMode.AdminEdit && formMode != FormMode.Readonly" class="btns-holder">
              <button type="button" class="btn SCAcustomBtn" Confirmation
                (confirmationClick)="DeleteSupplierSpeciality(i)"
                *ngIf="getFormControls.SupplierSpecialities.controls.length > 1">
                {{'FRONT_USER.DELETE' | translate }}
              </button>
            </p>
            <hr />
            <!-- ADD_BUTTON Button-->
            <p *ngIf="formMode != FormMode.AdminEdit &&  last && formMode!= FormMode.Readonly && IsSupplierRegistrationAvailable" class="btns-holder">
              <!-- <button type="button" class="btn SCAcustomBtn" (click)="AddSupplierSpeciality(i,last)">
                {{'FRONT_USER.ADD' | translate}}
              </button> -->
              <button type="button" class="btn SCAcustomBtn" Confirmation
                (confirmationClick)="AddSupplierSpeciality(i,last)">
                {{'FRONT_USER.ADD_NEW_CATEGORY' | translate}}
              </button>
            </p>
          </div>
        </div>
        <!-- Next-Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(2)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(4)">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---SUPPLIER_PARTNERSHIP_INFO TAB-->
      <tab #supplierPartnershipsTab [disabled]="disableTabs"
        heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_PARTNERSHIP_INFO' | translate}}">
        <!-- formGroupName="SupplierPartnershipsTab" -->
        <div formArrayName="SupplierPartnerships" class="form-container">
          <div
            *ngFor="let supplierPartnership of getFormControls.SupplierPartnerships.controls; let i=index; let last = last"
            [formGroupName]="i">
            <div class="form-container">
              <!-- CONTACT_PERSON_NAME Text-->
              <div class="form-group">
                <label
                  for="txtPartnerName">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.PARTNER_NAME' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="PartnerName" id="txtPartnerName" class="form-control"
                  name="txtPartnerName"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierPartnership.get('PartnerName')?.dirty && supplierPartnership.get('PartnerName')?.errors) }" />
                <div *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('PartnerName')?.invalid"
                  class="red">
                  <div *ngIf="supplierPartnership?.get('PartnerName')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="supplierPartnership?.get('PartnerName')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierPartnership?.get('PartnerName')?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
              </div>
              <!-- NATIONALITY Singel-Select-DDL-->
              <div class="form-group">
                <label for="ddlNationalityId">
                  {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.NATIONALITY' | translate}}
                </label>
                <span class="red"> *</span>
                <select formControlName="NationalityId" id="ddlNationalityId" class="form-control"
                  name="ddlNationalityId">
                  <option [value]="''" selected>
                    {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                  </option>
                  <ng-container *ngFor="let nationality of nationalities">
                    <option *ngIf="currentLanguage == Languages.English" [value]="nationality.Id">
                      {{nationality.NameEN}}
                    </option>
                    <option *ngIf="currentLanguage == Languages.Arabic" [value]="nationality.Id">
                      {{nationality.NameAR}}
                    </option>
                  </ng-container>
                </select>
                <div *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('NationalityId')?.invalid"
                  class="red ">
                  <div *ngIf="supplierPartnership?.get('NationalityId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                </div>
              </div>
              <!-- REGISTRATION_DATE DatePicker -->
              <div class="form-group">
                <label
                  for="dpRegisterationDate">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.REGISTRATION_DATE' | translate}}</label>
                <span class="red"> *</span>
                <input formControlName="RegisterationDate" id="dpRegisterationDate" class="form-control"
                  placeholder="{{datePlaceHolder}}" name="dpRegisterationDate" [minDate]="null" [maxDate]="getTodayDate"
                  #datepickerYMD="bsDatepicker" bsDatepicker formControlName="RegisterationDate"
                  [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' , minMode : hour}"
                  [ngClass]="{ 'is-invalid': formSubmitted ||(supplierPartnership.get('RegisterationDate')?.dirty  && supplierPartnership.get('RegisterationDate').errors) }">
                <div
                  *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('RegisterationDate')?.invalid"
                  class="red ">
                  <div *ngIf="supplierPartnership?.get('RegisterationDate')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div
                    *ngIf="supplierPartnership?.get('RegisterationDate')?.errors?.inValidDateError && !supplierPartnership?.get('RegisterationDate')?.errors?.required">
                    {{'FRONT_USER.DATE_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- PARTNER_WEBSITE Text-->
              <div class="form-group">
                <label
                  for="txtPartnerWebsiteURL">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.PARTNER_WEBSITE' | translate}}</label>
                <!-- <span class="red">*</span> -->
                <input type="text" formControlName="PartnerWebsiteURL" id="txtPartnerWebsiteURL" class="form-control"
                  name="txtPartnerWebsiteURL"
                  [ngClass]="{ 'is-invalid':formSubmitted ||( supplierPartnership.get('PartnerWebsiteURL')?.dirty && supplierPartnership.get('PartnerWebsiteURL')?.errors) }" />
                <div
                  *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('PartnerWebsiteURL')?.invalid"
                  class="red">
                  <!-- <div *ngIf="supplierPartnership?.get('PartnerWebsiteURL')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div> -->
                  <div *ngIf="supplierPartnership?.get('PartnerWebsiteURL')?.errors?.pattern">
                    {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.WEBSITE_ERROR' | translate}}
                  </div>
                  <div *ngIf="supplierPartnership?.get('PartnerWebsiteURL')?.errors?.maxlength">
                    {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- CATEGORY Multi-Select-DDL-->
              <div class="form-group">
                <label for="msddlCategory">
                  {{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CATEGORY' | translate}}
                </label>
                <span class="red"> *</span>
                <ng-multiselect-dropdown id="msddlCategory" formControlName ="SelectedSupplierPartnershipCategories"
                  placeholder="{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}"
                  [settings]="multiDropDownSettings" [data]="categories"
                  [disabled]="formMode == FormMode.Readonly || formMode == FormMode.AdminEdit">
                </ng-multiselect-dropdown>
                <!-- [ngModel]="SelectedSupplierPartnershipCategories" -->
                <div
                  *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('SelectedSupplierPartnershipCategories')?.invalid"
                  class="red">
                  <div *ngIf="supplierPartnership?.get('SelectedSupplierPartnershipCategories')?.errors?.required">
                    {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
                  </div>
                </div>
              </div>
              <!-- ATTACHMENT Uploder-->
              <div class="form-group">
                <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.ATTACHMENT' | translate}}</label>
                <span class="red"> *</span>
                <div class="read-uploaded"
                  *ngIf="formMode != FormMode.Add && supplierPartnership['controls']['SupplierCommercialAgencyCopyURL'].value != ''">
                  <a id="uploaderPartnershipAttachmentURL"
                    [attr.href]="uploadUrl + supplierPartnership['controls']['SupplierCommercialAgencyCopyURL'].value"
                    target="_blank">
                    <i class="icon-view-file"></i>
                    {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                  </a>
                </div>
                <div *ngIf="(formMode != FormMode.Readonly && formMode != FormMode.AdminEdit)">
                  <!-- Uploder -->
                  <input type="file" formControlName="PartnershipAttachment" id="uploaderPartnershipAttachment"
                    class="form-control" name="uploaderPartnershipAttachment" MaxSizeInMB="5"
                    accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                    (change)="AddAttachmentFile($event, supplierPartnership.get('PartnershipAttachment'), 'SupplierRegistration_PartnershipAttachment', 'partnershipAttachmentProgress', i, false, false, true, null, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.ATTACHMENT')" />
                  <!-- Description About File [Size - Allowed EXT.] -->
                  <div class="upload-info">
                    <span data-toggle="tooltip"
                      title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
                    <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
                  </div>
                  <div class="upload-info">
                    <span>
                      {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_PARTNERSHIP_INFO.ATTACHMENT_DESCRIPTION' | translate}} 
                    </span>
                  </div>
                  <!-- Progress Bar -->
                  <!-- <div class="progress">
                  <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                    [style.width]="partnershipAttachmentProgress + '%'">
                    <span class=""> {{partnershipAttachmentProgress}} % Complete</span>
                  </div>
                </div> -->
                  <!-- Required validate Message -->
                  <div
                    *ngIf="(isTabFiveSubmitted || formSubmitted) && supplierPartnership?.get('PartnershipAttachment')?.invalid"
                    class="red">
                    <div *ngIf="supplierPartnership?.get('PartnershipAttachment')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="supplierPartnership?.get('PartnershipAttachment')?.errors &&
                                !supplierPartnership?.get('PartnershipAttachment')?.errors?.required">
                      {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- DELETE_BUTTON Button-->
            <p *ngIf="formMode != FormMode.AdminEdit && formMode != FormMode.Readonly" class="btns-holder">
              <!-- <button type="button" class="btn SCAcustomBtn" (click)="DeleteSupplierPartnership(i)"
                *ngIf="getFormControls.SupplierPartnerships.controls.length > 1">
                {{'FRONT_USER.DELETE' | translate }}
              </button> -->
              <button type="button" class="btn SCAcustomBtn" Confirmation
                (confirmationClick)="DeleteSupplierPartnership(i)"
                *ngIf="getFormControls.SupplierPartnerships.controls.length > 0">
                {{'FRONT_USER.DELETE' | translate }}
              </button>
            </p>
            <hr />
          </div>
        </div>
        <!-- ADD_BUTTON Button-->
        <p *ngIf="formMode != FormMode.AdminEdit && formMode!= FormMode.Readonly" class="btns-holder">
          <!-- <button type="button" class="btn SCAcustomBtn" (click)="AddSupplierPartnership()">
            {{'FRONT_USER.ADD' | translate}}
          </button> -->
          <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="AddSupplierPartnership()">
            {{'FRONT_USER.ADD' | translate}}
          </button>
        </p>
        <!-- Next-Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(3)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(5) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---SUPPLIER_MAINTENANCE_INFO TAB-->
      <tab #supplierMaintenanceTab [disabled]="disableTabs"
        heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_MAINTENANCE_INFO' | translate}}">
        <div formGroupName="SupplierMaintenanceTab" class="form-container">
          <!-- MAINTENANCE_CENTER_ADDRESS Text-->
          <div class="form-group">
            <label
              for="txtMaintenanceCenterAddress">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_MAINTENANCE_INFO_TAB.MAINTENANCE_CENTER_ADDRESS' | translate}}</label>
            <input type="text" formControlName="MaintenanceCenterAddress" id="txtMaintenanceCenterAddress"
              class="form-control" name="txtMaintenanceCenterAddress" />
            <div *ngIf="formSubmitted && getSupplierMaintenanceTabControls?.MaintenanceCenterAddress?.invalid"
              class="red">
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceCenterAddress?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_500_ERROR' | translate}}
              </div>
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceCenterAddress?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- CONTACT_PERSON_NAME Text-->
          <div class="form-group">
            <label
              for="txtMaintenanceContactPerson">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CONTACT_PERSON_NAME' | translate}}</label>
            <input type="text" formControlName="MaintenanceContactPerson" id="txtMaintenanceContactPerson"
              class="form-control" name="txtMaintenanceContactPerson" />
            <div *ngIf="formSubmitted && getSupplierMaintenanceTabControls?.MaintenanceContactPerson?.invalid"
              class="red">
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceContactPerson?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
              </div>
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceContactPerson?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>
          </div>
          <!-- PHONE Text-->
          <div class="form-group">
            <label
              for="txtMaintenancePhone">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.PHONE' | translate}}</label>
            <input type="text" formControlName="MaintenancePhone" id="txtMaintenancePhone" class="form-control"
              name="txtMaintenancePhone" />
            <div *ngIf="formSubmitted && getSupplierMaintenanceTabControls?.MaintenancePhone?.invalid" class="red">
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenancePhone?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenancePhone?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_11_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!-- FAX Text-->
          <div class="form-group">
            <label for="txtMaintenanceFax">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.FAX' | translate}}</label>
            <input type="text" formControlName="MaintenanceFax" id="txtMaintenanceFax" class="form-control"
              name="txtMaintenanceFax" />
            <div *ngIf="formSubmitted && getSupplierMaintenanceTabControls?.MaintenanceFax?.invalid" class="red">
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceFax?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="getSupplierMaintenanceTabControls?.MaintenanceFax?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>
          </div>
          <!--TERMS_CONDITIONS CheckBox - Link-->
          <!-- <div class="form-group">
            <label
              for="cbTermsAndConditions">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_MAINTENANCE_INFO_TAB.TERMS_AND_CONDITIONS' | translate }}</label>
            <div class="custom-checkbox">
              <input type="checkbox" formControlName="TermsAndConditions" id="cbTermsAndConditions" class="form-control"
                name="cbTermsAndConditions" />
              <a href="#">
                <label
                  for="TermsAndConditions">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_MAINTENANCE_INFO_TAB.TERMS_AND_CONDITIONS_ACCEPTANCE' | translate }}</label>
              </a>
            </div>
          </div> -->
        </div>
        <!-- Next-Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(4)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(6) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---SUPPLIER_Environment_Certificates TAB-->
      <tab #supplierCertificatesTab [disabled]="disableTabs" heading="{{ 'FRONT_USER.SUPPLIER_TABS.SUPPLIER_CERTIFICATES_INFO' | translate}}">
        <div formGroupName="SupplierCertificates">
          <div *ngFor="let supplierCertificate of getFormControls.SupplierCertificates.controls; let i=index; let last = last" [formGroupName]="i">
          <div class="form-container">
              <!-- Certificate Type -->
              <div class="form-group">
                <label for="CertificateTypeId">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CERTIFICATES_INFO_TAB.CERTIFICATE_TYPE' | translate}}</label>
                <span class="red">*</span>
                <select formControlName="CertificateTypeId" class="form-control" (change)="OnCertificateTypeChange($event,i)">
                  <option [value]="''" selected>
                    {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CHOOSE' | translate}}
                  </option>
                  <ng-container *ngFor="let supplierCertificateTypesKey of supplierCertificateTypesKeys">
                    <option [value]="supplierCertificateTypes[supplierCertificateTypesKey]">
                      {{supplierCertificateTypesKey}}
                    </option>
                  </ng-container>
                </select>
                <div *ngIf="(isTabSevenSubmitted || formSubmitted) && supplierCertificate?.get('CertificateTypeId')?.invalid" class="red ">
                  <div *ngIf="supplierCertificate?.get('CertificateTypeId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                </div>
              </div>

              <!-- Certificate Type Other -->
              <div *ngIf="showCertificateTypeOther.includes(i)" class="form-group">
                <label for="CertificateTypeOther">{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CERTIFICATES_INFO_TAB.CERTIFICATE_TYPE_OTHER'| translate}}</label>
                <span class="red">*</span>
                <input type="text" name="CertificateTypeOther" id="CertificateTypeOther" class="form-control" formControlName="CertificateTypeOther" />
                  <div *ngIf="(isTabSevenSubmitted || formSubmitted) && supplierCertificate?.get('CertificateTypeOther')?.invalid" class="red ">
                    <div *ngIf="supplierCertificate?.get('CertificateTypeOther')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="supplierCertificate?.get('CertificateTypeOther')?.errors?.maxlength">
                      {{'FRONT_USER.TEXT_MAX_LENGTH_100_ERROR' | translate}}
                    </div>
                    <div *ngIf="supplierCertificate?.get('CertificateTypeOther')?.errors?.startsWithSpaceError">
                      {{'FRONT_USER.START_WITH_SPACE' | translate}}
                    </div>
                  </div>
              </div>


              <!-- Attachment -->
                <div class="form-group">
                  <label>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CERTIFICATES_INFO_TAB.ATTACHMENT' | translate}}</label>
                  <span class="red"> *</span>
                  <div class="read-uploaded"
                    *ngIf="formMode != FormMode.Add && supplierCertificate['controls']['CertificateCopyURL'].value != ''">
                    <a id="uploaderCertificateCopyURL"
                      [attr.href]="uploadUrl + supplierCertificate['controls']['CertificateCopyURL'].value"
                      target="_blank">
                      <i class="icon-view-file"></i>
                      {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                    </a>
                  </div>
                  <div *ngIf="(formMode != FormMode.Readonly && formMode != FormMode.AdminEdit)">
                    <!-- Uploder -->
                    <input type="file" formControlName="Certificate" id="Certificate"
                      class="form-control" name="Certificate" MaxSizeInMB="50"
                      accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                      (change)="AddCertificateFile($event,supplierCertificate['controls']['Certificate'] , 'SupplierRegistration_Certificate', 'certificateCopyProgress', i, 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CERTIFICATES_INFO_TAB.ATTACHMENT')" />
                      <!-- ,.zip,.ZIP,.rar,.RAR -->
                    <!-- Description About File [Size - Allowed EXT.] -->
                    <!-- <div class="upload-info">
                      <span>
                        {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.EXPERIENCE_DESCRIPTION' | translate}}
                      </span>
                    </div> -->
                    <div class="upload-info">
                      <span data-toggle="tooltip"
                        title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">
                        {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.ExperienceAllowedFileExtentions' | translate}}
                      </span>
                      <span>
                        {{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SUPPLIER_CATEGORIES_TAB.ExperienceMaxFileSize' | translate}}
                      </span>
                    </div>
                    <div
                      *ngIf="(isTabSevenSubmitted || formSubmitted) && supplierCertificate?.get('Certificate')?.invalid"
                      class="red ">
                      <div *ngIf="supplierCertificate?.get('Certificate')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                      <div *ngIf="supplierCertificate?.get('Certificate')?.errors &&
                                 !supplierCertificate?.get('Certificate')?.errors?.required">
                        {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
                            
              <!-- Delete Certificate -->
              <p *ngIf="formMode != FormMode.AdminEdit && formMode != FormMode.Readonly" class="btns-holder">
                  <button type="button" class="btn SCAcustomBtn" Confirmation
                    (confirmationClick)="DeleteSupplierCertificate(i)"
                    *ngIf="getFormControls.SupplierCertificates.controls.length > 1">
                    {{'FRONT_USER.DELETE' | translate }}
                  </button>
              </p>
              <!-- Add Certificate -->
                <!-- <p *ngIf="formMode != FormMode.AdminEdit && (last || !getFormControls?.SupplierCertificates || getFormControls?.SupplierCertificates?.controls?.length < 1) && formMode!= FormMode.Readonly" class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="AddSupplierCertificate()">
                  {{'FRONT_USER.ADD' | translate}}
                </button>
              </p> -->
            </div>  
            <hr />
          </div>
        </div>
        <!-- ADD_BUTTON Button-->
        <p *ngIf="formMode != FormMode.AdminEdit && formMode!= FormMode.Readonly" class="btns-holder">
          <!-- <button type="button" class="btn SCAcustomBtn" (click)="AddSupplierPartnership()">
            {{'FRONT_USER.ADD' | translate}}
          </button> -->
          <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="AddSupplierCertificate()">
            {{'FRONT_USER.ADD' | translate}}
          </button>
        </p>
        <!-- Previous -->
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(5)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
        </p>
      </tab>
    </tabset>
  </div>
</form>
</div>
<!-- Submit Button -->
<ng-container
  *ngIf="checkFormControlsValid() && formMode != FormMode.Readonly && formMode != FormMode.Add && !editCompleted">
  <div class="form-group">
    <button type="button" class="btn SCAcustomBtn"
      (click)="editSupplier()">{{'ADMIN_USER.SUPPPLIER_FORMS.Submit'| translate}}</button>
  </div>
</ng-container>


<!-- Supplier Registration is Not Available -->
 <div *ngIf="!IsSupplierRegistrationAvailable && formMode == FormMode.Add" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-warning"></i>
    <p>{{'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.REGISTRATION_NOT_AVAILABLE' | translate}} ({{getFormattedMonthNames}})</p>
  </div>
</div> 

<!-- Edit Confirmation Success -->
<div *ngIf="editCompleted" class="alert alert-success" role="alert">
  <div class="alignC">
    <i class="icon-success"></i>
    <p>{{'ADMIN_USER.SUPPPLIER_FORMS.AccountEdited'| translate}}</p>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a *ngIf="currentUser?.IsAdmin" href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
      <a *ngIf="!currentUser?.IsAdmin" href="{{workspaceUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.Workspace'| translate}}
      </a>
    </p>
  </div>
</div>

<!-- Submit Fail -->
<div *ngIf="submitFail" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>
    <hr>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a *ngIf="currentUser?.IsAdmin" href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
      <a *ngIf="!currentUser?.IsAdmin" href="{{workspaceUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.Workspace'| translate}}
      </a>
    </p>
  </div>
</div>

<!-- Messaging Box -->
<div
  *ngIf="(formMode != FormMode.Edit || formMode != FormMode.AdminEdit) && requestId && basicRegistrationInfoResponseObj?.Data?.IsApproved">
  <app-messaging [RegestRequestId]="requestId"></app-messaging>
</div>